import { APPOINTMENT_DETAILS_GA_CATEGORY } from '../../pages/AppointmentDetails/constants';
import { createGaActionCreator } from '../../utils';
import { ACTION_PREFIX, GaActionText } from './constants';

export const REQUIREMENTS_VALIDATION_CHANGE = `${ACTION_PREFIX}/REQUIREMENTS_VALIDATION_CHANGE`;
export const TRACK_SHOW_REQUIRED_ADDRESS_FIELD = `${ACTION_PREFIX}/TRACK_SHOW_REQUIRED_ADDRESS_FIELD`;
export const SHOW_VALIDATION_ERRORS = `${ACTION_PREFIX}/SHOW_VALIDATION_ERRORS`;

export function validationChange(isValid) {
    return {
        type: REQUIREMENTS_VALIDATION_CHANGE,
        payload: {
            isValid,
        },
    };
}

export function showValidationErrors(insuranceIdRequired) {
    return {
        type: SHOW_VALIDATION_ERRORS,
        insuranceIdRequired,
    };
}

export const trackShowRequiredAddressField = () =>
    createGaActionCreator(
        TRACK_SHOW_REQUIRED_ADDRESS_FIELD,
        APPOINTMENT_DETAILS_GA_CATEGORY,
        GaActionText.trackShowRequiredAddressField
    );

export const GaActionCreators = {
    trackShowRequiredAddressField,
};
